import { useMemo } from "react";

import { useDownstreamMachines } from "@/hooks/machines";

export const useDownstreamMachineAliasLookup = () => {
	const { machines: downstreamMachines, isLoading, error } = useDownstreamMachines();

	const aliasMap = useMemo(() => {
		return new Map(downstreamMachines.map((m) => [m.id, m.alias]));
	}, [downstreamMachines]);

	const getMachineAlias = (machineId: string | null | undefined): string | null => {
		if (!machineId) return null;

		if (isLoading || error) return machineId;

		return aliasMap.get(machineId) ?? "";
	};

	return { getMachineAlias };
};
